import { render, staticRenderFns } from "./ChatForm.vue?vue&type=template&id=6597a523&scoped=true"
import script from "./ChatForm.vue?vue&type=script&lang=js"
export * from "./ChatForm.vue?vue&type=script&lang=js"
import style0 from "./ChatForm.vue?vue&type=style&index=0&id=6597a523&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6597a523",
  null
  
)

export default component.exports